import {inject, Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {finalize, Observable} from 'rxjs';
import {SpinnerService} from "./spinner.service";

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private readonly spinnerService = inject(SpinnerService);

  // Paths to exclude from showing spinner (any HTTP method)
  // These are background operations that should not display loading indicators
  private readonly excludedPaths: string[] = [
    '/auth/',           // Keycloak auth endpoints (token refresh, etc.)
    '/openid-connect/', // OIDC protocol endpoints
    '/realms/'          // Keycloak realm endpoints
  ];

  // Paths to exclude from showing spinner for GET requests only
  private readonly excludedGetPaths: string[] = [
    '/api/photos/'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const showSpinner = this.shouldShowSpinner(req);

    if (showSpinner) {
      this.spinnerService.show();
    }

    return next.handle(req)
      .pipe(
        finalize(() => {
          if (showSpinner) {
            this.spinnerService.hide();
          }
        })
      );
  }

  private shouldShowSpinner(req: HttpRequest<any>): boolean {
    // Exclude auth-related endpoints for all methods (background token refresh)
    if (this.excludedPaths.some(path => req.url.includes(path))) {
      return false;
    }

    // Check if this is a GET request to an excluded path
    if (req.method === 'GET') {
      return !this.excludedGetPaths.some(path => req.url.includes(path));
    }

    // Show spinner for all other non-GET requests
    return true;
  }

}
